module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/daaridna-bkg-0d15a1398c287df2e7f3777ea981b408.jpg";